export type PlanType = 'free' | 'pro';

export type FeatureId = 'review' | 'draft' | 'playbooks' | 'chat';

export interface PlanConfig {
  label: string;
  features: FeatureId[];
  dailyLimit: number;
}

export const PLANS: Record<PlanType, PlanConfig> = {
  free: {
    label: 'Free',
    features: ['review'],
    dailyLimit: 20,
  },
  pro: {
    label: 'Pro',
    features: ['review', 'draft', 'playbooks', 'chat'],
    dailyLimit: 100,
  },
};
